import { useCallback, useMemo, useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { AutoCompleteSelect } from '../../../../components';
import Dialog from '../../../../components/Dialog';
import { bedStatusAPI } from '../../../../apis';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#7d86a9',
  },
  content: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#2e4469',
  },
}));

const EditFloorPlan = ({ handleFloorPlanOpen, wardList }) => {
  const classes = useStyles();
  const history = useHistory();

  const [form, setForm] = useState({ ward: '' });

  const itemList = useMemo(() => {
    let list = [];

    list = _.map(wardList, (item) => ({
      text: item.wardLocation,
      value: item.wardLocation,
    }));

    return list;
  }, [wardList]);

  const handleSelectWard = (value) => {
    setForm({ ward: value });
  };

  const handleSubmit = useCallback(async () => {
    try {
      const data = _.find(wardList, (item) => item.wardLocation === form.ward);
      const { result } = await bedStatusAPI.createFloorPlan(data);
      history.push(`/newBedstatus/editFloorPlan/${result.id}`);
    } catch (error) {
      console.log(error);
    }
  }, [form, history, wardList]);

  return (
    <Dialog
      open={true}
      title="Edit Floorplan"
      cancel="Cancel"
      confirm="Confirm"
      cancelStyle={{ border: 'unset' }}
      handleCancel={handleFloorPlanOpen(false)}
      handleClose={handleFloorPlanOpen(false)}
      handleConfirm={handleSubmit}
      disabled={!form.ward}
    >
      <Box display="flex" flexDirection="column" gridGap="2.5rem">
        <div className={classes.content}>In edit mode, can only edit one ward location floor plan at a time.</div>
        <Box display="flex" flexDirection="column" gridGap="0.5rem">
          <div className={classes.title}>Ward</div>
          <AutoCompleteSelect
            placeholder="Please Select"
            itemList={itemList}
            value={form.ward}
            onChange={handleSelectWard}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default EditFloorPlan;
